module.exports = __webpack_public_path__ + "img/img2.2a151998.png";